export default function (obj) {
  // array can have objects like { text: 'Test', value: 'TEST', disabled: false }
  return []
}
